export const formatStatus = (status) => {
  if(!status || status === 'new') {
    return 'Unpaid';
  }
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export const round = (value, decimals) =>
  Number(Math.round(value+'e'+decimals)+'e-'+decimals);
